import React from 'react';

function StatusRenderer(props) {
  const status = props.data["Status"];

  let label = ""
  let statusClass = "";

  switch (status) {
    case false:
      statusClass = "status-draft";
      label = "Draft";
      break;
    case true:
      statusClass = "status-committed";
      label = "Committed";
      break;
    default:
      break;
  }

  

  return (
    <div className={`d-flex justify-content-center align-items-center status-container ${statusClass}`}>
      <p className='status-text mb-0 fw-bold'>{label.toUpperCase()}</p>
    </div>
  )
}

export default StatusRenderer